import { render, staticRenderFns } from "./ModalCopy.vue?vue&type=template&id=845bbe82&scoped=true&"
import script from "./ModalCopy.vue?vue&type=script&lang=js&"
export * from "./ModalCopy.vue?vue&type=script&lang=js&"
import style0 from "./ModalCopy.vue?vue&type=style&index=0&id=845bbe82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845bbe82",
  null
  
)

export default component.exports